import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BookingDotComActionModel extends Model {
  @attr('boolean') noShow!: boolean;
  @attr('boolean') invalidCreditCard!: boolean;

  @belongsTo('booking', { inverse: 'bookingDotComAction', async: false })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-dot-com-action': BookingDotComActionModel;
  }
}
